import { Button } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { ComponentPropsWithoutRef, FunctionComponent, PropsWithChildren } from 'react'

interface Props extends ComponentPropsWithoutRef<'button'> {
  asChild?: boolean
}

const Tag: FunctionComponent<PropsWithChildren<Props>> = ({ className, asChild = false, children, ...props }) => {
  return (
    <Button
      size='default'
      variant='secondaryStatic'
      className={cn('hover:bg-secondary/20 group normal-case hover:backdrop-blur-none [&_svg]:size-2', className)}
      asChild={asChild}
      {...props}
    >
      {children}
    </Button>
  )
}

export { Tag }
